import { Navigate, useLocation } from "react-router-dom";

import {
  browserLocationChanged,
  sanitizedBrowserLocation,
} from "./urlPrivacy";

/**
 * Re-applies the URL privacy boundary after in-app navigation. It renders no
 * UI and replaces unsafe history entries before the browser paints the route.
 */
export default function BrowserUrlPrivacyGuard({ children = null }) {
  const location = useLocation();
  const safe = sanitizedBrowserLocation(location);

  if (browserLocationChanged(location, safe)) {
    return <Navigate to={`${safe.pathname}${safe.search}${safe.hash}`} replace />;
  }

  return children;
}
